import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tag-status',
  templateUrl: './tag-status.component.html',
  styleUrl: './tag-status.component.css'
})
export class TagStatusComponent {

  @Input() status!: string;

  getStatus(): string {

    let stt = '';

    switch (this.status) {
      case "IT":
        stt = "Integrado";
        break;
      case "IP":
        stt = "Enviando ao PIMS";
        break;
      case "AP":
        stt = "Aguardando Pesagem";
        break;
      case "IE":
        stt = "Pendente Envio ao ERP";
        break;
      case "ER":
        stt = "Erro";
        break;
      case "GC":
        stt = "Gerando Certificado";
        break;
      case "NI":
        stt = "Pendente integração";
        break;
      case "EP":
        stt = "Em processamento";
        break;
      case "RI":
        stt = "Retornar ID/PIMS";
        break;
      case "AE":
        stt = "Aguardando Emissão";
        break;
      case "ES":
        stt = "Estornado";
        break;
      case "CP":
        stt = "Cancelamento Pendente";
        break;
      case "CA":
            stt = "Cancelado";
            break;
      case "PA":
            stt = "Pendente Aprovação";
            break;
      case "PENDENTE":
            stt = "Pendente";
            break;
      case "APROVADO":
            stt = "Aprovado";
            break;
      case "REPROVADO":
            stt = "Reprovado";
            break;
      case "CANCELADO":
            stt = "Cancelado";
            break;
      case "NAO_INTEGRADO":
            stt = "Não Integrado";
            break;
      case "INTEGRADO":
      case "SUCESSO":
        stt = "Integrado";
        break;
      case "ERRO":
        stt = "Erro";
        break;
      case "NAO_INTEGRADO":
      case "PENDENTE_ENVIO":
        stt = "Pendente Integração";
        break;
      case "ESTORNADO":
        stt = "Estornado";
        break;
      case "CANCELADO":
        stt = "Cancelado";
        break;
      case "AGUARD_EMISSAO":
      case "AGUARDANDO_EMISSAO":
        stt = "Aguardando Emissão";
        break;
      case "CANCELAR_PIMS":
        stt = "Aguardando Emissão";
        break;
      case "AGUARDANDO_PATIO":
        stt = "Aguardando Pátio";
        break;
      case "PESANDO_ENTRADA":
        stt = "Pesando Entrada";
        break;
      case "AGUARDANDO_SAIDA":
        stt = "Aguardando Saída";
        break;
      case "PESANDO_SAIDA":
        stt = "Pesando Saída";
        break;
      case "CONCLUIDO":
        stt = "Concluído";
        break;
      /** PE - Pendente: remessa registrada mas ainda não liberada. */
      case "PE":
        stt = "Pendente";
        break;
      /** LI - Liberado: remessa liberada pelo SAP, pronta para pesagem. */
      case "LI":
        stt = "Liberado";
        break;
      /** CA - Cancelado: remessa cancelada pelo SAP, não permite pesagem. */
      case "CA":
        stt = "Cancelado";
        break;
      /** AC - Abastecendo Carga: pesagem em andamento (pelo menos peso 1 confirmado). */
      case "AC":
        stt = "Abastecendo Carga";
        break;
      /** AL - Aguardando Lacre: lacre obrigatório mas ainda não preenchido (após peso 2). */
      case "AL":
        stt = "Aguardando Lacre";
        break;
      /** AA - Aguardando Análise: produto é álcool e análise ainda não foi preenchida. */
      case "AA":
        stt = "Aguardando Análise";
        break;
      /** NC - Não Consistente: SAP retornou erro na integração, aguarda correção. */
      case "NC":
        stt = "Não Consistente";
        break;
      /** PC - Pesagem Concluída: integração com SAP confirmada com sucesso. */
      case "PC":
        stt = "Pesagem Concluída";
        break;
      case "ERRO_INTEGRACAO":
            stt = "Erro na Integração";
            break;
      case "PEND_APROVACAO":
            stt = "Pendente Aprovação";
            break;
      case "TENTA_EXCEDIDA":
        stt = "Tentativas Excedida";
        break;
      case "LIBERADO":
        stt = "Liberado";
        break;
      case "BLOQUEADO":
        stt = "Bloqueado";
        break;
      default:
        stt = this.status;
        break;
    }

    return stt;

  }

  getSeverity(): string {
    let stt = '';

    switch (this.status) {
      case "IT":
      case "APROVADO":
      case "INTEGRADO":
        case "SUCESSO":
        stt = "success";
        break;
      case "ER":
      case "REPROVADO":
      case "ERRO_INTEGRACAO":
      case "ERRO":
        stt = "danger";
        break;
      case "PENDENTE":
      case "PA":
      case "NAO_INTEGRADO":
      case "TENTA_EXCEDIDA":
        stt = "warning";
        break;
      case "CANCELADO":
      case "CA":
        stt = "secondary";
        break;

      case "NAO_INTEGRADO":
        stt = "info";
        break;
      case "AGUARDANDO_PATIO":
        stt = "info";
        break;
      case "PESANDO_ENTRADA":
        stt = "info";
        break;
      case "AGUARDANDO_SAIDA":
        stt = "info";
        break;
      case "PESANDO_SAIDA":
        stt = "info";
        break;
      case "CONCLUIDO":
        stt = "success";
        break;
      /** PE - Pendente: remessa registrada mas ainda não liberada. */
      case "PE":
        stt = "secondary";
        break;
      /** LI - Liberado: remessa liberada pelo SAP, pronta para pesagem. */
      case "LI":
        stt = "info";
        break;
      /** CA - Cancelado: remessa cancelada pelo SAP, não permite pesagem. */
      case "CA":
        stt = "danger";
        break;
      /** AC - Abastecendo Carga: pesagem em andamento (pelo menos peso 1 confirmado). */
      case "AC":
        stt = "warning";
        break;
      /** AL - Aguardando Lacre: lacre obrigatório mas ainda não preenchido (após peso 2). */
      case "AL":
        stt = "warning";
        break;
      /** AA - Aguardando Análise: produto é álcool e análise ainda não foi preenchida. */
      case "AA":
        stt = "warning";
        break;
      /** NC - Não Consistente: SAP retornou erro na integração, aguarda correção. */
      case "NC":
        stt = "danger";
        break;
      /** PC - Pesagem Concluída: integração com SAP confirmada com sucesso. */
      case "PC":
        stt = "success";
        break;
      case "PEND_APROVACAO":
        stt = "warning";
        break;
      case "LIBERADO":
        stt = "success"
        break;
      default:
        stt = "info";
        break;
    }

    return stt;
  }

  getStyle(): { [key: string]: string } {
    switch (this.status) {
      /** PE - Pendente: remessa registrada mas ainda não liberada. */
      case "PE":
        return { background: '#64748b', color: '#fff' };
      /** LI - Liberado: mesma cor de Pendente Integração (info PrimeNG). */
      /** CA - Cancelado: remessa cancelada pelo SAP, não permite pesagem. */
      case "CA":
        return { background: '#ef4444', color: '#fff' };
      /** AC - Abastecendo Carga: pesagem em andamento (pelo menos peso 1 confirmado). */
      case "AC":
        return { background: '#d97706', color: '#fff' };
      /** AA - Aguardando Análise: produto é álcool e análise ainda não foi preenchida. */
      case "AA":
        return { background: '#0d9488', color: '#fff' };
      /** NC - Não Consistente: SAP retornou erro na integração, aguarda correção. */
      case "NC":
        return { background: '#dc2626', color: '#fff' };
      /** PC - Pesagem Concluída: integração com SAP confirmada com sucesso. */
      case "PC":
        return { background: '#16a34a', color: '#fff' };
      default:
        return {};
    }
  }

}
